<template>
  <!-- 温馨提示 -->
  <div
    v-if="!inIosReview"
    :class="{
      'h5-tips-text': isH5,
      'pc-tips-text': !isH5,
      'electron-tips-text': isElectron,
    }"
  >
    <div class="title">温馨提示</div>
    <div class="sub-title">关于课程购买：</div>
    <div class="tips-content">
      为了保障个人权益，请在魔果云课平台内进行购买支付，私下交易造成的任何损失及纠纷，魔果云课不承担任何责任。
    </div>
    <div class="sub-title">关于观看课程：</div>
    <div class="tips-content">
      使用报名课程的账号登录魔果云课网站、App 及客户端即可进行课程学习。
    </div>
    <div class="sub-title">关于售后问题：</div>
    <div class="tips-content">
      <!-- 实时结算 -->
      <span v-if="orgInfo.settlement_cycle_type === 2">
        课程问题或退费需与授课教师及机构联系；
        <br />
        系统使用问题及建议可邮件联系 service@moguoyunke.com。
      </span>
      <!-- t+7计算 -->
      <span v-else>
        付款后7天内可在系统内申请退款，课程问题或后续退费需与授课教师及机构联系；
        <br />
        系统使用问题及建议可邮件联系 service@moguoyunke.com。
      </span>
    </div>
    <div class="more">
      更多上课相关说明可<span class="link" @click="viewMore">点击这里</span
      >查看。
    </div>
  </div>
</template>

<script>
import { isH5 } from "@saas/components/src";
export default {
  props: {
    orgInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: function () {
    return {
      isH5: isH5(),
      moreLink:
        "https://help.moguoyunke.com/guide/userguide.html#%E8%AF%BE%E7%A8%8B%E6%8A%A5%E5%90%8D",
      inIosReview: false,
      isElectron: window.isElectron,
    };
  },
  mounted() {
    this.inIosReview = this.$route.query?.inReview === "1";
  },
  methods: {
    // 点击查看更多
    viewMore() {
      if (window.isElectron) {
        window.openUrlByExternal(this.moreLink);
      } else {
        window.open(this.moreLink);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-tips-text {
  padding: 30px 34px;
  .title {
    font-weight: 500;
    font-size: 18px;
    color: #000000;
    line-height: 25px;
    margin-bottom: 16px;
  }
  .sub-title {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: $plain-text-color;
    margin-bottom: 8px;
  }
  .tips-content {
    font-weight: 400;
    font-size: 14px;
    color: $plain-text-color;
    line-height: 20px;
    margin-bottom: 16px;
  }
  .more {
    font-weight: 400;
    font-size: 14px;
    color: $plain-text-color;
    line-height: 20px;
  }
  .link {
    cursor: pointer;
    color: $saas-theme-color;
  }
}
.h5-tips-text {
  padding: 0.55rem 0.45rem;
  .title {
    font-weight: 500;
    font-size: 0.48rem;
    color: #000000;
    line-height: 0.67rem;
    margin-bottom: 0.43rem;
  }
  .sub-title {
    font-weight: 500;
    font-size: 0.37rem;
    color: $plain-text-color;
    line-height: 0.53rem;
    margin-bottom: 0.21rem;
  }
  .tips-content {
    font-weight: 400;
    font-size: 0.37rem;
    color: $plain-text-color;
    line-height: 0.53rem;
    margin-bottom: 0.4rem;
  }
  .more {
    font-weight: 400;
    font-size: 0.37rem;
    color: $plain-text-color;
    line-height: 0.53rem;
  }
  .link {
    color: $saas-theme-color;
  }
}
.electron-tips-text.pc-tips-text {
  padding: 24px 34px;
  .title {
    font-size: 16px;
    line-height: 22px;
  }
  .sub-title {
    font-size: 12px;
    line-height: 17px;
    margin-bottom: 6px;
  }
  .tips-content {
    font-size: 12px;
    line-height: 17px;
  }
  .more {
    font-size: 12px;
    line-height: 17px;
  }
}
</style>
